module.exports = __webpack_public_path__ + "dcc2fa6fb8b83acdfe4233d8f3357890.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fhird-logo-large.png
// module id = O7sS
// module chunks = 3